import * as React from 'react'
import { ChangeEvent } from 'react'

export function FileSelector({
  disabled = false,
  filesSelected,
  allowMultiple = true,
}: {
  disabled?: boolean
  filesSelected: (files: File[], webKitEntries: any[]) => void
  allowMultiple?: boolean
}) {
  function onChange(e: ChangeEvent<HTMLInputElement>) {
    filesSelected(
      Array.from(e.target.files || []),
      Array.from(e.target.webkitEntries),
    )
  }

  return (
    <input
      disabled={disabled}
      type="file"
      onChange={onChange}
      multiple={allowMultiple}
    />
  )
}
